<div class="customization-colors">
  <button
    type="button"
    style="font-size: 0.8rem"
    class="my-button-3 secondary"
    (click)="openModal()"
  >
    Select Color
  </button>

  <ng-template #colorPickerModal>
    <div class="modal-header">
      <h5 class="modal-title">Customize Colors</h5>
      <button type="button" class="close" aria-label="Close" (click)="closeModal()">
        <span aria-hidden="true">&times;</span>
      </button>
    </div>
    <div class="modal-body">
      <div class="color-section">
        <label class="color-picker-label">
          <span class="label-text">Map Side</span>
        </label>
        <div class="color-picker-field">
          <div class="color-picker-wrapper">
            <input
              type="color"
              class="color-input"
              [(ngModel)]="selectedMapSideColor"
              (ngModelChange)="handleMapSideColorInput($event)"
              #mapSideColorPicker
            />
            <span
              class="color-preview"
              [style.background]="selectedMapSideColor"
              (click)="mapSideColorPicker.click()"
            ></span>
          </div>
          <input
            type="text"
            class="hex-input"
            [(ngModel)]="selectedMapSideColor"
            (ngModelChange)="handleMapSideHexInput($event)"
            placeholder="#ffffff"
            maxlength="7"
          />
        </div>
      </div>

      <div class="color-section">
        <label class="color-picker-label">
          <span class="label-text">Map Header</span>
        </label>
        <div class="color-picker-field">
          <div class="color-picker-wrapper">
            <input
              type="color"
              class="color-input"
              [(ngModel)]="selectedMapHeaderColor"
              (ngModelChange)="handleMapHeaderColorInput($event)"
              #mapHeaderColorPicker
            />
            <span
              class="color-preview"
              [style.background]="selectedMapHeaderColor"
              (click)="mapHeaderColorPicker.click()"
            ></span>
          </div>
          <input
            type="text"
            class="hex-input"
            [(ngModel)]="selectedMapHeaderColor"
            (ngModelChange)="handleMapHeaderHexInput($event)"
            placeholder="#592880"
            maxlength="7"
          />
        </div>
      </div>

      <div class="color-section">
        <label class="color-picker-label">
          <span class="label-text">Popup Leader</span>
        </label>
        <div class="color-picker-field">
          <div class="color-picker-wrapper">
            <input
              type="color"
              class="color-input"
              [(ngModel)]="selectedPopupLeaderColor"
              (ngModelChange)="handlePopupLeaderColorInput($event)"
              #popupLeaderColorPicker
            />
            <span
              class="color-preview"
              [style.background]="selectedPopupLeaderColor"
              (click)="popupLeaderColorPicker.click()"
            ></span>
          </div>
          <input
            type="text"
            class="hex-input"
            [(ngModel)]="selectedPopupLeaderColor"
            (ngModelChange)="handlePopupLeaderHexInput($event)"
            placeholder="#592880"
            maxlength="7"
          />
        </div>
      </div>

      <div class="color-section">
        <label class="color-picker-label">
          <span class="label-text">FAQ Question Field</span>
        </label>
        <div class="color-picker-field">
          <div class="color-picker-wrapper">
            <input
              type="color"
              class="color-input"
              [(ngModel)]="selectedFaqQuestionFieldColor"
              (ngModelChange)="handleFaqQuestionFieldColorInput($event)"
              #faqQuestionFieldColorPicker
            />
            <span
              class="color-preview"
              [style.background]="selectedFaqQuestionFieldColor"
              (click)="faqQuestionFieldColorPicker.click()"
            ></span>
          </div>
          <input
            type="text"
            class="hex-input"
            [(ngModel)]="selectedFaqQuestionFieldColor"
            (ngModelChange)="handleFaqQuestionFieldHexInput($event)"
            placeholder="#592880"
            maxlength="7"
          />
        </div>
      </div>
    </div>
    <div class="modal-footer">
      <button 
        type="button" 
        class="btn btn-outline-warning btn-sm reset-btn" 
        (click)="resetToDefaults()"
        [disabled]="isSaving"
      >
        <i class="fas fa-undo-alt"></i> Reset to Default
      </button>
      <div class="footer-actions">
        <button 
          type="button" 
          class="btn btn-outline-secondary btn-sm" 
          (click)="closeModal()"
          [disabled]="isSaving"
        >
          Cancel
        </button>
        <button 
          type="button" 
          class="btn btn-primary btn-sm" 
          (click)="confirmSelection()"
          [disabled]="isSaving"
        >
          <span *ngIf="!isSaving">Apply</span>
          <span *ngIf="isSaving">
            <i class="fas fa-spinner fa-spin"></i> Saving...
          </span>
        </button>
      </div>
    </div>
  </ng-template>
</div>

